/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimit/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimit/slot-launcher/bin/NolimitPlugin";
import {LogLevel} from "@nolimit/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimit/slot-game/bin/flowcontrol/GameFlowController";
import {GameMode} from "@nolimit/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimit/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimit/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimit/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimit/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimit/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimit/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimit/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimit/slot-game/bin/asset/ResourcesGroupName";
import {NineToFiveGameAssets} from "./NineToFiveGameAssets";
import {NineToFiveSound} from "./sound/NineToFiveSound";
import {NineToFiveBackgroundElements} from "./view/NineToFiveBackgroundElements";
import {NineToFiveWinPresentation} from "./gameflow/NineToFiveWinPresentation";
import {NineToFiveBetPresentation} from "./gameflow/NineToFiveBetPresentation";
import {NineToFiveNormalResultPresentation} from "./gameflow/NineToFiveNormalResultPresentation";
import {NineToFiveIdleNormalPresentation} from "./gameflow/NineToFiveIdleNormalPresentation";
import {NineToFiveModel} from "./server/NineToFiveModel";
import {NineToFiveWinView} from "./view/NineToFiveWinView";
import {NineToFiveTransitionScreenView} from "./view/NineToFiveTransitionScreenView";
import {TemplateAsset, TemplateLoader} from "@nolimit/slot-launcher/bin/loader/TemplateLoader";
import {NineToFiveStatics} from "./config/NineToFiveStatics";
import {RestoreUtils} from "./utils/RestoreUtils";
import {NineToFiveBaseGameReelView} from "./reels/NineToFiveBaseGameReelView";
import {NineToFiveXBetView} from "./view/NineToFiveXBetView";
import {NineToFiveSymbolFactory} from "./reels/symbols/SymbolFactory";
import {NineToFiveFreespinsIdlePresentation} from "./gameflow/NineToFiveFreespinsIdlePresentation";
import {NineToFiveForegroundElements} from "./view/NineToFiveForegroundElements";
import {NineToFivePopUpView} from "./view/NineToFivePopUpView";


export class NineToFive extends SlotGame {
    public static model: NineToFiveModel;
    public static assetLoader: AssetLoader;
    public static soundPlayer: NineToFiveSound;
    public static gameFlowController: GameFlowController;

    public static backgroundElements: NineToFiveBackgroundElements;
    public static foregroundElements: NineToFiveForegroundElements;
    public static popUpView: NineToFivePopUpView;
    public static xBetView: NineToFiveXBetView;
    public static baseGameReelView: NineToFiveBaseGameReelView;
    public static winView: NineToFiveWinView;
    public static transitionScreen: NineToFiveTransitionScreenView;
    public static symbolFactory: NineToFiveSymbolFactory;


    constructor() {
        super();
    }

    public static isWinBelowStake(): boolean {
        return NineToFive.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (this.getAccumulatedRoundWin() <= this.getBetPrice());
    }

    public static isWinAboveStake(): boolean {
        return this.getAccumulatedRoundWin() > this.getBetPrice();
    }

    public static getBetPrice(): number {
        const betLevel: string = NineToFive.apiPlugin.freeBets.hasFreeBets() ? NineToFive.apiPlugin.freeBets.getBet() : NineToFive.apiPlugin.betLevel.getLevel();
        let price: number = NineToFive.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (NineToFive.model.data.wasFeatureBuy || NineToFive.model.data.boostedBet) {
            for (let index = 0; index < NineToFive.model.initData.featureBuyTimesBetValue.length; index++) {
                if (NineToFive.model.initData.featureBuyTimesBetValue[index].name === NineToFive.model.buyFeatureName) {
                    price *= NineToFive.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    private static getAccumulatedRoundWin(): number {
        return NineToFive.model.data.accumulatedRoundWin;
    }

    getNoWinGameData(): any {
        return {
            "reels": [
                [
                    "L3",
                    "M1",
                    "L4",
                    "M4",
                    "L2",
                    "M3"
                ],
                [
                    "L4",
                    "L1",
                    "L3",
                    "M1",
                    "L4",
                    "M2"
                ],
                [
                    "M4",
                    "L2",
                    "M3",
                    "L1",
                    "M4",
                    "M2"
                ],
                [
                    "M2",
                    "M1",
                    "M3",
                    "L4",
                    "L3",
                    "M4"
                ],
                [
                    "L4",
                    "L3",
                    "M2",
                    "L1",
                    "L4",
                    "M4"
                ]
            ],
            "evaluatedArea": [
                [
                    "M1",
                    "L4",
                    "M4",
                    "L2"
                ],
                [
                    "L1",
                    "L3",
                    "M1",
                    "L4"
                ],
                [
                    "L2",
                    "M3",
                    "L1",
                    "M4"
                ],
                [
                    "M1",
                    "M3",
                    "L4",
                    "L3"
                ],
                [
                    "L3",
                    "M2",
                    "L1",
                    "L4"
                ]
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "wasFeatureBuy": false,
            "brokeTheBank": false,
            "freeSpinsPlayed": 0,
            "freespinsLeft": 0,
            "boostedBet": false,
            "serverTestInfo": {},
            "symbolSizes": [
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1,
                    1
                ]
            ],
            "xNudgeMultipliers": [
                1,
                1,
                1,
                1,
                1
            ],
            "fsMultiplier": 1,
            "accumulatedFSWin": 0,
            "sfsNextMultiplier": 1
        };
    }


    public getSymbolString(key: string, data: {
        3: number,
        4: number,
        5: number,
        6: number,
        7: number,
        8: number,
        9: number
    }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>
        `;


    }

    public getPaytable(): Promise<string> {
        const templateLoader = new TemplateLoader(SlotGame.apiPlugin.resources.getStaticRoot());
        templateLoader.add({
            name: "Paytable",
            url: "nolimit/screens/paytable.mustache"
        });


        let symbolDataValueData = NineToFiveStatics.defaultSymbolValues;
        if (NineToFive.model?.symbolValues) {
            symbolDataValueData = NineToFive.model.symbolValues;
            console.log("Using symbolValues from INIT data");
        } else {
            console.log("Using default symbolValues ");
        }

        // return templateLoader.load().then((assets: TemplateAsset[]) => {
        //     for (let asset of assets) {
        //         if (asset.name == "Paytable" && asset.loadedData) {
        //             for (let key in symbolDataValueData) {
        //                 asset.loadedData = asset.loadedData!.replace(`{{${key}}}`, this.getSymbolString(key, symbolDataValueData[key]))
        //             }
        //             asset.loadedData = asset.loadedData!.replace(`{{godModeValue}}`, this.getGodModeValue());
        //             return asset.loadedData;
        //         }
        //     }
        //     throw new Error("SlotGame could not load Paytable");
        // });
            return super.getPaytable().then((text:string)=>{
                const data: any = {
                    godModeValue: this.getGodModeValue(),
                    replaceWincapInfo: NineToFive.apiPlugin.gameClientConfiguration.replaceWincapInfo
                }
            for (let key in symbolDataValueData) {
            text = text.replace(`{{${key}}}`, this.getSymbolString(key, symbolDataValueData[key]))
            }
            return NineToFive.apiPlugin.translations.render(text, data);
            });
        }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            (<any>globalThis).__PIXI_APP__ = NolimitApplication.pixiApp;
            NineToFive.symbolFactory = new NineToFiveSymbolFactory();
            NineToFive.model = new NineToFiveModel(SlotGame.apiPlugin, true);
            NineToFive.gameFlowController = new GameFlowController(SlotGame.apiPlugin, NineToFive.model);
            NineToFive.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            const normalBet = new NineToFiveBetPresentation();
            const normalResult = new NineToFiveNormalResultPresentation();
            const normalWinPres = new NineToFiveWinPresentation();

            const freespinsIdle = new NineToFiveFreespinsIdlePresentation();

            NineToFive.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, new NineToFiveIdleNormalPresentation()],
                [FlowState.BET, normalBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, normalWinPres]
            ]));
            NineToFive.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, freespinsIdle],
                //[FlowState.BET, freespinsBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, normalWinPres]
            ]));
            NineToFive.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN_SUPER, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, freespinsIdle],
                //[FlowState.BET, freespinsBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, normalWinPres]
            ]));

            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            AssetsConfig.addToAssetsConfig(NineToFiveGameAssets.RESOURCES_GROUPS);
            NineToFive.assetLoader = new AssetLoader(NineToFive.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), NineToFive.assetLoader.load(ResourcesGroupName.MAIN)]);

            return promises.then((values: any) => {

                this.createViewsAndComponents();

                return value;
            });
        });
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value: NolimitPlugin) => {

            RestoreUtils.startupGame();
            NineToFive.soundPlayer.switchMusic("INTRO");

            return value;
        });
    }

    public start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            NineToFive.gameFlowController.start();
            NineToFive.soundPlayer.switchMusic(NineToFive.model.data.mode);
            if (!NineToFive.model.isRestore && !NineToFive.apiPlugin.isReplay) {
                NineToFive.soundPlayer.playSound("gameStartOneShot");
                NineToFive.foregroundElements.showGameIntro();
            }
            NineToFive.popUpView.showPopUp();
            if (NineToFive.model.data.mode == GameMode.NORMAL) {
                NineToFive.xBetView.visible = true;
            }
            return value;
        });
    }

    private getGodModeValue(): string {
        for (let i: number = 0; i < NineToFive.model.initData.featureBuyTimesBetValue.length; i++) {
            if (NineToFive.model.initData.featureBuyTimesBetValue[i].name === "GOD_MODE") {
                return NineToFive.model.initData.featureBuyTimesBetValue[i].price.toString();
            }
        }

        return "";
    }

    private createViewsAndComponents() {
        //Non views
        NineToFive.soundPlayer = new NineToFiveSound();

        //Static views
        NineToFive.backgroundElements = new NineToFiveBackgroundElements();
        NineToFive.baseGameReelView = new NineToFiveBaseGameReelView();
        NineToFive.popUpView = new NineToFivePopUpView();
        NineToFive.xBetView = new NineToFiveXBetView();
        NineToFive.foregroundElements = new NineToFiveForegroundElements();
        NineToFive.winView = new NineToFiveWinView();
        NineToFive.transitionScreen = new NineToFiveTransitionScreenView();

        NolimitApplication.addLayerAt(NineToFive.transitionScreen.name, NineToFive.transitionScreen, 0);
        NolimitApplication.addLayerAt(NineToFive.winView.name, NineToFive.winView, 0);
        NolimitApplication.addLayerAt(NineToFive.popUpView.name, NineToFive.popUpView, 0);
        NolimitApplication.addLayerAt(NineToFive.xBetView.name, NineToFive.xBetView, 0);
        NolimitApplication.addLayerAt(NineToFive.foregroundElements.name, NineToFive.foregroundElements, 0);
        NolimitApplication.addLayerAt(NineToFive.baseGameReelView.name, NineToFive.baseGameReelView, 0);
        NolimitApplication.addLayerAt(NineToFive.backgroundElements.name, NineToFive.backgroundElements, 0);
    }
}